import React, { Fragment, useCallback, useMemo } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useDispatch } from "react-redux";
import { setModal } from "../../redux/application-slice";

interface LearnQuestionsModalProps {
  open: boolean;
}

function LearnQuestionsModal({ open }: LearnQuestionsModalProps) {
  const dispatch = useDispatch();

  const onClose = useCallback(() => {
    dispatch(setModal(null));
  }, [dispatch]);

  const dialogContent = useMemo(() => {
    return (
      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-[calc(100vw-200px)] sm:h-[calc(100vh-200px)]">
        <div className="h-full w-full">
          <div className="p-6 h-full flex flex-col">
            <Dialog.Title
              as="h3"
              className="text-lg font-semibold leading-6 text-gray-900 mb-4"
            >
              How to Ask Questions with Provision
            </Dialog.Title>
            <div className="flex-grow">
              <iframe
                src="https://www.loom.com/embed/4a8ff1f3663949248abe74a66d5d5dc6?sid=1cf1eb8a-fddb-4c94-8510-3eecfdfc96d0"
                frameBorder="0"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
            <div className="mt-6 flex justify-end">
              <button
                type="button"
                className="rounded-md w-full bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-600  transition-colors"
                onClick={onClose}
              >
                Go Back to Chat
              </button>
            </div>
          </div>
        </div>
      </Dialog.Panel>
    );
  }, [onClose]);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              {dialogContent}
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default LearnQuestionsModal;
